import TokensApiService from './_services/tokens.api.service';

import { ActionTypes, MutationTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    tokens: [],
  },
  mutations: {
    [MutationTypes.SET_TOKENS](state, payload) {
      state.tokens = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_TOKENS]({ commit }, { pageNum, ...rest }) {
      commit(MutationTypes.SET_TOKENS, await TokensApiService.getTokens({ pageNum, ...rest }));
    },
  },
};
